import { ScheduleSerializer } from "@models/serializers/scheduleSerializer";
import { httpRequest } from "../../http";

export class CommandGetScheduleTree {
    async run(scheduleId: number) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/schedules/${scheduleId}/tree`
       
        try {
            const response = await httpRequest<any>(url, { method: "GET" });
            return this.deserialize(response);
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) {
        return new ScheduleSerializer().deserialize(data)
    }

  
}



